import { render, staticRenderFns } from "./TheRevisit.vue?vue&type=template&id=b0b7adfc&scoped=true&lang=pug&"
import script from "./TheRevisit.vue?vue&type=script&lang=js&"
export * from "./TheRevisit.vue?vue&type=script&lang=js&"
import style0 from "./TheRevisit.vue?vue&type=style&index=0&id=b0b7adfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b7adfc",
  null
  
)

export default component.exports